import { createContext, useContext } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../store/types/store";
import { Spin } from "antd";
import { Loader } from "./Loader";

// Define the shape of the AuthContext value
interface AuthContextType {
  isAuth: boolean;
}

// Create the context with a default value of null
const AuthContext = createContext<AuthContextType | null>(null);

// AuthProvider Component
export const AuthProvider: any = ({ children }: any) => {
  const { isAuthenticated, loading } = useSelector(
    (state: RootState) => state.user
  );
  let isAuthFromLocalStorage = false;
  if (!isAuthenticated) {
    isAuthFromLocalStorage = localStorage.getItem("isAuthenticated") === "true";
  }
  const isAuth = isAuthenticated ? isAuthenticated : isAuthFromLocalStorage;

  return (
    <AuthContext.Provider value={{ isAuth }}>
      <Spin spinning={loading} indicator={<Loader />}>{children}</Spin>
    </AuthContext.Provider>
  );
};

// Custom hook to use the AuthContext
export const useAuth = (): AuthContextType => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
